import { ScopeChangeRequestItem } from 'admin/scope-change-requests/ScopeChangeRequest'
import { once } from 'lodash'
import { makeObservable, observable, reaction } from 'mobx'
import { greaterThanOrEqual } from 'utils/validation-utils'
import { validationContext } from 'validx'

export default class CostPerCustomServiceViewModel {
  @observable fromItem: ScopeChangeRequestItem
  @observable newPrice: number | null = null
  @observable newProPrice: number | null = null

  validation = validationContext(this, {
    newPrice: [greaterThanOrEqual(0, `Can't be negative`)],
    newProPrice: [greaterThanOrEqual(0, `Can't be negative`)],
  })

  constructor(item: ScopeChangeRequestItem, private onPriceUpdate: () => void) {
    this.fromItem = item
    this.newPrice = item.price
    this.newProPrice = item.proPrice
    makeObservable(this)
    reaction(() => [this.newPrice, this.newProPrice], this.onPriceUpdate, {
      delay: 500,
    })
  }

  validate() {
    return this.validation.reset().validate().isValid
  }

  static get none() {
    return lazyNone()
  }
}

const lazyNone = once(
  () =>
    new CostPerCustomServiceViewModel(new ScopeChangeRequestItem(), () =>
      Promise.resolve()
    )
)
